import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled.
   * When value is at min, we keep the minus button enabled so that clicking it
   * removes the line item instead of decreasing the quantity.
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    const atMin = value <= min;
    minusButton.disabled = false;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
    this.dataset.atMin = atMin ? 'true' : 'false';
  }

  /**
   * When at min (e.g. qty=1), clicking minus removes the line item
   * instead of decreasing below the minimum.
   * @param {Event} event
   */
  decreaseQuantity(event) {
    const { value, min } = this.getCurrentValues();
    if (value <= min) {
      event.preventDefault();
      const row = this.closest('[data-key]') || this.closest('.cart-items__table-row');
      const removeBtn = row?.querySelector('.cart-items__remove');
      if (removeBtn instanceof HTMLElement) {
        removeBtn.click();
        return;
      }
    }
    super.decreaseQuantity(event);
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
